import { Validators } from '@quickbit/qb-design-system';
import { Merchant } from 'tabs/types';

const validateFeeValue = (value: number) => {
  if (value > 99) return 'The fee is too high.';
  const isValidFee = value === 0 || /^\d*(\.\d{0,2})?$/.test(`${value}`);
  if (!isValidFee)
    return 'Invalid fee, supports values up to 2 decimal places.';
  return undefined;
};

export const merchantValidators: Validators<Merchant, Merchant> = {
  name: (name: string) => (name.length < 1 ? 'Can not be empty.' : undefined),
  displayName: (displayName: string) => {
    if (displayName.trim().length < 1) {
      return 'Can not be empty.';
    }
    if (displayName.length > 255) {
      return 'display name is too long';
    }
    return undefined;
  },
  paymentDetails: {
    iban: (iban: string) => {
      if (iban.length < 1) return 'Can not be empty.';
      if (iban.length > 34) return 'Can not be longer than 34 characters.';
      return undefined;
    },
    bic: (bic: string) => {
      if (bic.length < 1) return 'Can not be empty.';
      if (bic.length > 11) return 'Can not be longer than 11 characters.';
      return undefined;
    },
    reference: (reference: string) => {
      if (reference.length < 1) return 'Can not be empty.';
      if (reference.length > 255)
        return 'Can not be longer than 255 characters.';
      return undefined;
    },
  },
  payFee: {
    value: validateFeeValue,
  },
  onrampFee: {
    value: validateFeeValue,
  },
  processingFee: {
    value: validateFeeValue,
  },
  customerFee: {
    value: (value: number) => {
      if (value > 99) return 'The fee is too high.';
      const isValidFee = value === 0 || /^\d*(\.\d{0,2})?$/.test(`${value}`);
      if (!isValidFee)
        return 'Invalid fee, supports values up to 2 decimal places.';
      return undefined;
    },
  },
  config: {
    amountToleranceLowerBound: (data: number) =>
      data > 1 || data < 0
        ? 'Lower bound has to be between 0 and 100%.'
        : undefined,
    amountToleranceUpperBound: (data: number) =>
      data < 1 ? 'Upper bound has to be 100% or more.' : undefined,
    minutesToCancelOrderAfter: (data: number) =>
      data < 0 ? 'Needs to be positive.' : undefined,
  },
};
